var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheck70 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 70,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M63.803 9.102a.5.5 0 0 1 .095.7l-38 50a.5.5 0 0 1-.752.052l-18-18a.5.5 0 1 1 .708-.707L25.448 58.74 63.102 9.197a.5.5 0 0 1 .7-.095Z",
  clipRule: "evenodd"
})));
export { SvgCheck70 as ReactComponent };
export default __webpack_public_path__ + "93a2406ced5bb4b337aabb0b59d67413.svg";